export type DateTimeObject = {
    day: number;
    month: number;
    year: number;
    time: string;
};

// Covert from DST to Lt
export function convertFromDST(dateTime: DateTimeObject): DateTimeObject {
    const [hours, minutes] = dateTime.time.split(":").map(Number);

    const date = new Date(dateTime.year, dateTime.month - 1, dateTime.day, hours, minutes);

    const isDST = isDaylightSavingTime(date);

    if (!isDST) {
        date.setHours(date.getHours() - 1);
    }

    return {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear(),
        time: date.toTimeString().slice(0, 5),
    };
}


// Covert from DST to Lt
export function convertFromWinter(dateTime: DateTimeObject): DateTimeObject {
    const [hours, minutes] = dateTime.time.split(":").map(Number);
    const date = new Date(dateTime.year, dateTime.month - 1, dateTime.day, hours, minutes);

    // Check if the month is between November (11) and February (2)
    if (date.getMonth() + 1 >= 11 || date.getMonth() + 1 <= 2) {
        date.setHours(date.getHours() - 1);
    }

    return {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear(),
        time: date.toTimeString().slice(0, 5),
    };
}

// Check is DST works
function isDaylightSavingTime(date: Date): boolean {
    const january = new Date(date.getFullYear(), 0, 1).getTimezoneOffset();
    const july = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
    const current = date.getTimezoneOffset();

    return current < Math.max(january, july);
}

